import * as constants from '../../constants';

export const headerStyle = () => {
    return {
        borderColor: '#a81933',
    };    
};

export const columnStyle = () => {
    return {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    };
};

const activityTypeValues = [
    {
        "id": 277,
        "name": "To Do"
    },
    {
        "id": 278,
        "name": "Call"
    },
    {
        "id": 279,
        "name": "Email"
    },
    {
        "id": 280,
        "name": "SMS"
    },
    {
        "id": 281,
        "name": "Letter"
    },
    {
        "id": 365,
        "name": "Calendar"
    }
]

export const columns = [
    {
        dataField: 'activityTypeId',
        text: 'Type',
        sort: true,
        headerStyle: () => { return { width: '10%', ...headerStyle() }; },
        formatter: (_cell, row) => {
            return activityTypeValues.filter(activityType => activityType.id === row.activityTypeId)[0].name;
        }
    },
    {
        dataField: 'description',
        text: 'Description',
        sort: true,
        headerStyle: () => { return { width: '18%', ...headerStyle() }; },
    },
    {
        dataField: 'dueDays',
        text: 'Days',
        sort: true,
        headerStyle: () => { return { width: '18%', ...headerStyle() }; },
        formatter: (_cell, row) => {
            if(row.executionTypeId === constants.ACTIVITYPLANEXECUTIONTYPE_PERFORMIMMEDIATELY){
                return 'Immediately';
            } else if (row.dueDays >= 0) {
                return row.dueDays
            } else {
                return '-';
            }
        }
    },
    {
        dataField: 'triggerFieldType.formattedDisplayName',
        text: 'Based On',
        sort: true,
        headerStyle: () => { return { width: '19%', ...headerStyle() }; },
    },
    {
        dataField: 'reminderSendDays',
        text: 'Reminder',
        sort: true,
        headerStyle: () => { return { width: '10%', ...headerStyle() }; },
        formatter: (_cell, row) => {
            if(row.reminderSendDays == null){
                return '-';
            } else if(row.reminderSendDays === 1) {
                return row.reminderSendDays + ' day';
            } else {
                return row.reminderSendDays + ' days';
            }
        }
    },
    {
        dataField: 'dropOffDays',
        text: 'Drop Off',
        sort: true,
        headerStyle: () => { return { width: '10%', ...headerStyle() }; },
        formatter: (_cell, row) => {
            if(row.activityTypeId === 365 || row.dropOffDays == null){
                return '-';
            } else if(row.dropOffDays === 1) {
                return row.dropOffDays + ' day';
            } else {
                return row.dropOffDays + ' days';
            }
        }
    },
    {
        dataField: 'assignTo.name',
        text: 'Assigned To',
        sort: true,
        headerStyle: () => { return { width: '10%', ...headerStyle() }; },
        formatter: (_cell, row) => {
            if(row.assignTo && row.assignTo.name){
                return row.assignTo.name;
            } else if (row.activityTypeId != 365 && row.isAutomaticTrigger === true){
                return 'Send Automatically';
            } else {
                return '-';
            }
        }
        
    }
];

export const sorting = [{
    dataField: 'name',
    order: 'asc'
}];